import api from "../../config/client.axios.api";

export const updateMachineApi = async (infoUpdate: any) => {
  const response = await api.put(`/machine`, infoUpdate);
  return response.data;
};
